import React from 'react';
import './TodoClipBoard.css';

function TodoClipBoard() {
  
  return (
    <div className='container'>
		<div className='circulo'>
			<div className='inside-circle'></div>
		</div>
	    <div className='rectangulo'></div>
	</div>
  );
}

export { TodoClipBoard };